import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", { class: "c-icon" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-plus" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 추가 ")
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "대표 이미지"),
    /*#__PURE__*/_createVNode("th", null, "제목"),
    /*#__PURE__*/_createVNode("th", null, "하위 제목"),
    /*#__PURE__*/_createVNode("th", null, "상태"),
    /*#__PURE__*/_createVNode("th", null, "노출 순서"),
    /*#__PURE__*/_createVNode("th", null, "설정")
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "badge bg-success text-white"
}
const _hoisted_10 = {
  key: 1,
  class: "badge bg-danger text-white"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-trash" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-pencil" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_PaginationV2 = _resolveComponent("PaginationV2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary mb-3",
            to: { name: 'AddAskCategories' }
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_6, [
            _createVNode("table", _hoisted_7, [
              _hoisted_8,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: category.id
                  }, [
                    _createVNode("td", null, [
                      _createVNode("img", {
                        src: category.thumbnail,
                        height: "50"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("td", null, _toDisplayString(category.name), 1),
                    _createVNode("td", null, _toDisplayString(category.sub_name), 1),
                    _createVNode("td", null, [
                      (category.status)
                        ? (_openBlock(), _createBlock("span", _hoisted_9, "Active"))
                        : _createCommentVNode("", true),
                      (!category.status)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, "Disabled"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, _toDisplayString(category.order_number), 1),
                    _createVNode("td", null, [
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.deleteRecord(category.id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_11
                        ], 2)
                      ], 8, ["disabled", "onClick"]),
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.editRecord(category.id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_12
                        ], 2)
                      ], 8, ["disabled", "onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_PaginationV2, {
            "data-model": _ctx.CrudModel,
            "order-options": _ctx.orderOptions,
            "filter-conditions": _ctx.filterConditions,
            onDataChanged: _ctx.updateData,
            onIsLoading: _ctx.isLoading,
            limit: _ctx.perpage
          }, null, 8, ["data-model", "order-options", "filter-conditions", "onDataChanged", "onIsLoading", "limit"])
        ])
      ], 2)
    ])
  ]))
}